import * as XLSX from 'xlsx';

export interface ExcelColumn<T> {
  header: string;
  accessor: (row: T) => string | number;
}

export function exportToExcel<T>(
  filename: string,
  sheetName: string,
  columns: ExcelColumn<T>[],
  rows: T[],
): void {
  const headers = columns.map(c => c.header);
  const data = rows.map(row => columns.map(c => c.accessor(row)));
  const ws = XLSX.utils.aoa_to_sheet([headers, ...data]);

  ws['!cols'] = columns.map(c => ({ wch: Math.max(c.header.length + 2, 14) }));

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName.slice(0, 31));

  const safeName = filename.endsWith('.xlsx') ? filename : `${filename}.xlsx`;
  XLSX.writeFile(wb, safeName);
}
